if not App.angularApp?
    return

# mfResizable vertically resizes the element relative to the target
#
# CSS/jQuery basics:
#   height = height of element
#   innerHeight = height + padding
#   outerHeight = height + padding + border
#   outerHeight(true) = height + padding + border + margin
#
# if no Target is defined, then the direct parent is used
#
# Limitations:
#   - Assumes that the target is an ancestor of the element. You will get undefined behavior otherwise.
#   - This will probably not work properly if any direct children of the target (or the element itself)
# is floated left or right. This directive assumes that all the children are stacked vertically on top of each other.
#
App.angularApp.directive 'mfResizable', [
    '$window'
    '$parse'
    '$timeout'
    '$rootScope'
    ($window, $parse, $timeout, $rootScope) ->
        return {
            restrict: 'A',
            link:
                post: (scope, element, attrs) =>
                    undefined

                # We use the pre-link function, because it executes on parent first, then child
                # This is necessary because we need to compute heights top-down for nested
                # resizable directives
                pre: (scope, element, attrs) =>

                    active = true

                    # Parse the options
                    target_selector = attrs.mfResizable

                    if target_selector? and target_selector isnt ''
                        if target_selector[0] is '{'
                            options = $parse(target_selector)(scope)
                            target_element = element.closest(options.target)
                            active = !!options.active
                        else
                            target_element = element.closest(target_selector)
                    else
                        target_element = element.parent()

                    return if not active

                    debug = false

                    # Set up the resize function
                    resizeit = () ->
                        # Angular might not have hidden child elements yet. Wait for it to apply bindings to the view.
                        $timeout () =>
                            console.log element if debug

                            # Hide the element
                            element.hide()

                            # Calculate the inner height of the target element
                            target_height = target_element.height()
                            console.log target_element if debug
                            console.log "target_height=#{target_height}" if debug

                            # Calculate the outer height of all the target's children
                            height_of_children = 0
                            for child in target_element.children()
                                child = angular.element(child)
                                # Child must be visible to be counted. (The element
                                # we're resizing is hidden, so it isn't counted.)
                                # Child must either not be floated (takes up vertical space) or must be an ancestor of the element
                                if child.is(':visible') and
                                (child.css('float') is 'none' or element.closest(child).length > 0)
                                    height_of_children += child.outerHeight(true)
                            console.log "height_of_children=#{height_of_children}" if debug

                            # Calculate how big our element can be without causing target to scroll
                            available_height = target_height - height_of_children

                            # Show our element again
                            element.show()

                            # Calculate height due to margin, border, and padding of our element
                            element_padding = element.outerHeight(true) - element.height()
                            console.log "element_padding=#{element_padding}" if debug

                            # Calculate how big the inside can be
                            new_height = available_height - element_padding

                            # Set the height
                            if attrs.mfResizableAdjustment?
                                adjustment = parseFloat attrs.mfResizableAdjustment
                                final_height = new_height + adjustment
                                element.height(new_height + adjustment)

                                console.log "adjustment=#{adjustment}" if debug
                                console.log "final_height=#{final_height}" if debug

                            else
                                console.log "final_height=#{new_height}" if debug
                                element.height(new_height)

                            $rootScope.$broadcast('resizable:resized')
                        , parseInt(attrs.mfResizableDelay ? 0)

                    # Need to initialize on load
                    resizeit()

                    # resize on window resize
                    debounced = debounce () -> resizeit()
                    angular.element($window).on 'resize', debounced

                    # don't create duplicate/persistent event handlers
                    scope.$on '$destroy', () ->
                        angular.element($window).off 'resize', debounced
        }
]
